export const PARENT_AUDIT_TABS=['overview','math','verify','crew','library','guide','settings'] as const;
export function parentAuditTab(hash:string){const value=new URLSearchParams(hash.slice(1)).get('audit-parent');return PARENT_AUDIT_TABS.find(tab=>tab===value)??null;}
